// UnverifiedGuestsList_SingleVerify.jsx
import React, { useEffect, useState } from "react";
import {
  Alert,
  Button,
  Row,
  Col,
  Table,
  Input,
  Spinner,
  Modal,
    ModalBody,
    Container,
    Card,   
    CardBody   
} from "reactstrap";
import axios from "axios";
import { store } from './utils/httpUtil'; // your existing helper

// core components
import Header from "./Header";
import isOnline from 'is-online';
import { Link } from "react-router-dom";

const UnverifiedGuestsSubmittedDocs = () => {
  

  const [guests, setGuests] = useState([]);
  const [loading, setLoading] = useState(false);
  const [alert, setAlert] = useState({ show: false, color: "success", msg: "" });

const [modalMD, setModalMD] = React.useState(false);

  useEffect(() => {
    fetchGuests();
  }, []);

  const fetchGuests = async () => {
    setLoading(true);
    try {
      const res = await axios.get("/apiDocs");
      const normalized = (res.data || []).map((g) => ({
        ...g,
        is_passport_verified: !!g.is_passport_verified,
        is_visa_verified: !!g.is_visa_verified,
        is_cform_verified: !!g.is_cform_verified,
        is_indianid_verified: !!g.is_indianid_verified,
        is_declarationform_verified: !!g.is_declarationform_verified,
        is_entrystamp_verified: !!g.is_entrystamp_verified
      }));
      setGuests(normalized);
    } catch (err) {
      console.error(err);
      showAlert("danger", "Failed to load unverified guests.");
    } finally {
      setLoading(false);
    }
  };

  const showAlert = (color, msg, timeoutMs = 5000) => {
    setAlert({ show: true, color, msg });
    if (timeoutMs) {
      setTimeout(() => setAlert({ show: false, color: "success", msg: "" }), timeoutMs);
    }
  };

  const docItemsForGuest = (g) => {
    const items = [];
    const isIndia = Number(g.country_id_passport) === 107;

    if (isIndia) {
      if (g.indian_doc_url) {
        items.push({
          key: "indianid",
          label: "Indian ID",
          docUrl: g.indian_doc_url,
          verified: g.is_indianid_verified
        });
      }
      if (g.dform_doc_url) {
        items.push({
          key: "declarationform",
          label: "Declaration Form",
          docUrl: g.dform_doc_url,
          verified: g.is_declarationform_verified
        });
      }
    } else {
      if (g.passport_doc_url) {
        items.push({
          key: "passport",
          label: "Passport",
          docUrl: g.passport_doc_url,
          verified: g.is_passport_verified
        });
      }
      if (g.visa_doc_url) {
        items.push({
          key: "visa",
          label: "Visa",
          docUrl: g.visa_doc_url,
          verified: g.is_visa_verified
        });
      }
      if (g.cform_doc_url) {
        items.push({
          key: "cform",
          label: "C Form",
          docUrl: g.cform_doc_url,
          verified: g.is_cform_verified
        });
      }
    }

    return items;
  };


    if (sessionStorage.getItem("has_mandatory_docs_view") === 'false' || sessionStorage.getItem("has_mandatory_docs_view") === '0') {
        return (
            <>
            <Header selected="Docs"/>
            <div class="divErrorMsg">Sorry, no access!</div>);
            </> 
        );
    } else {
            return (
            <>
                <Modal
                modalClassName="modal-mini modal-danger"
                toggle={() => setModalMD(false)}
                isOpen={modalMD}>
                <div className="modal-header justify-content-center">
                    No internet!
                </div>
                <ModalBody>
                    <p>Oops, you are offline! Your data might not have saved.</p>
                </ModalBody>
                </Modal>

                <Header selected="Docs"/>
                <div className="wrapper">
                    <div className="section section-about-us">
                    <Container>
                        <h2 className="title">Pending Documents for Verification</h2>
                             
                <Row className="mb-2" style={{ marginTop:'-3em' }}>
                    <Col className="text-right">
                    
                    <Button color="primary" type="submit" onClick={fetchGuests} disabled={loading}>
                        {loading ? <Spinner size="sm" /> : "Refresh"}
                    </Button>
                    </Col>
                </Row>

                <Alert color={alert.color} isOpen={alert.show}>
                    {alert.msg}
                </Alert>

                {loading ? (
                    <div className="text-center"><Spinner /></div>
                ) : (
                    <>
                    {guests.length === 0 && <div>No pending docs found.</div>}

                        <Card>
                                    <CardBody>

                    <Table bordered responsive hover>
                        <thead>
                        <tr>
                            <th style={{ textAlign: "center" }}>#</th>
                            <th>Guest</th>
                            <th>Documents</th>
                        </tr>
                        </thead>
                        <tbody>
                        {guests.map((g, index) => {
                            const items = docItemsForGuest(g);
                            return (
                            <tr key={g.guest_id}>
                                <td style={{ textAlign: "center" }}> {index + 1} </td> 
                                <td>
                                <div style={{ fontWeight: 'bold' }}>
                                  <Link style={{ textDecoration:'underline', color:'blue'}} to={`/docDetails/?gId=${g.guest_id}`} target="_blank" rel="noopener noreferrer">
                                      {g.first_name} {g.last_name}
                                  </Link>    
                                </div>
                               
                                </td>
                                <td>
                                {items.length === 0 && <div style={{ color: "#666" }}>No uploaded docs (unexpected)</div>}
                                {items.map((it) => (
                                    <div key={it.key} style={{ display: "flex", alignItems: "center", gap: 10, marginBottom: 6 }}>
        
                                    <div style={{ flex: 1 }}>
                                        {it.docUrl ? (
                                            <strong>
                                        <a href={it.docUrl} target="_blank" rel="noreferrer" style={{color: it.verified ? "green" : "orange" }}>
                                            {it.label}
                                        </a>
                                        </strong>
                                
                                        ) : (
                                        <span style={{ color: "#666" }}>No file (flag-only)</span>
                                        )}
                                    </div>
                                    </div>
                                ))}
                                </td>
                               
                            </tr>
                            );
                        })}
                        </tbody>
                    </Table>
                    </CardBody>
                    </Card> 
                    </>
                )}
                {/* </div> */}
                                    </Container>
                                    </div>
                                </div>
                            </>     
            );
    }
}

 export default () => <UnverifiedGuestsSubmittedDocs />
